import { computed, ComputedRef } from 'vue';
import { useMainStore } from '@/stores/main';
import { usePage } from '@inertiajs/vue3';
import useAppData from '@/composables/useAppData';

export default (title: string) => computed(() => `${title} - ${usePage().props.appName}`);

export function usePageTitle() {
  const store = useMainStore();

  /**
   * Get page title from Vuex store.
   */
  const pageTitle: ComputedRef<string|null> = computed(() => usePage().props.title as string|null || store.pageTitle);

  /**
   * Set Page title
   */
  async function setPageTitle(title: string) {
    await store.setPageTitle(`${title} - ${useAppData().appName.value}`);
  }

  return {
    pageTitle,
    setPageTitle,
  };
}
